import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";

type Payload={
  appointmentId: string | null
  pipelineId: string | null
  pipelineArn: string | null
}
export const useStopRecord = () => {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationKey: ["stop recording"],
    mutationFn: async ({ appointmentId, pipelineId, pipelineArn }: Payload) => {
      const response = await http.post("/meeting/record/stop", { appointmentId, pipelineId, pipelineArn });
      return response.data;
    },

    onMutate: () => {
      const toastId = toast.loading("Please wait...");
      return { toastId };
    },
    onSuccess: (_data, _variables, context) => {
      const { toastId } = context;
      toast.update(toastId, {
        render: "Recording stopped",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
        toastId: 'recording-stopped',
      })
      queryClient.invalidateQueries({ queryKey: ['start recording'] as const});
    },

    onError: (error, _variables, context) => {
      const toastId = context?.toastId as number

      if (axios.isAxiosError(error)) {
        toast.update(toastId, {
          render: error?.response?.data?.error || "Error occured while stopping recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
          toastId: 'recording-error',
        })

      } else {
        toast.update(toastId, {
          render: error?.message || "An unexpected error occured while stopping recording",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          closeButton: true,
        });

      }
    }
  });

  return { stopRecording: mutate, ...rest };
}
